import { Routes } from '@angular/router';

import { AuthGuard } from '../core/guards/auth.guard';
import { MyAccountComponent } from '../pages/my-account/my-account.component';
import { OrdersComponent } from '../pages/orders/orders.component';
import { PendingOrdersComponent } from '../pages/pending-orders/pending-orders.component';
import { OrderDetailsComponent } from '../pages/order-details/order-details.component';
import { PlanDetailsComponent } from '../pages/plan-details/plan-details.component';
import { PlansComponent } from '../pages/plans/plans.component';
import { AccountDetailsComponent } from '../pages/account-details/account-details.component';
import { PlanPaymentComponent } from '../pages/plan-payment/plan-payment.component';
import { RegisterTokenComponent } from '../pages/register-token/register-token.component';

export const myAccountRoutes: Routes = [
  {
    path: 'my-account',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: MyAccountComponent },
      {
        path: 'plans/details/:planUuid/change-payment',
        component: PlanPaymentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plans/details/:planUuid',
        component: PlanDetailsComponent,
        canActivate: [AuthGuard],
      },
      { path: 'plans/details', redirectTo: 'plans', pathMatch: 'full' },
      { path: 'plans', component: PlansComponent, canActivate: [AuthGuard] },
      { path: 'account-details', component: AccountDetailsComponent, canActivate: [AuthGuard] },
      { path: 'orders/details/:id', component: OrderDetailsComponent, canActivate: [AuthGuard] },
      { path: 'orders/details', component: OrderDetailsComponent, canActivate: [AuthGuard] },
      { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
      {
        path: 'pending-orders/complete',
        component: RegisterTokenComponent,
        canActivate: [AuthGuard],
        data: { loggedInFlow: true },
      },
      { path: 'pending-orders', component: PendingOrdersComponent, canActivate: [AuthGuard] },
    ],
  },
];
